import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { PageCardType } from '@/types/card'
import { asPartnerLink } from '@/utils/helpers'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'

type Props = {
  budget?: string
  card: PageCardType
  tag?: string
}

const NavigationPanelTop = ({ budget, card, tag }: Props) => {
  const { dir } = useDirectories()
  const {
    background_chooser,
    cards,
    doctors_companion,
    is_partner,
    legal_commander,
    legal_companion,
    legal_partner,
    sanitized_wo,
    type,
  } = card
  const isPartnerPair = is_partner && cards?.length === 2

  const buildLink = (base: string) => `/${base}/${sanitized_wo}${tag ? `/${tag}` : ''}${budget ? `/${budget}` : ''}`

  return (
    <div className={styles.navButtons}>
      {legal_commander && (
        <LinkHelper scroll={false} href={buildLink('commanders')} primary={dir === 'commanders'}>
          As Commander
        </LinkHelper>
      )}
      {(legal_partner ||
        background_chooser ||
        doctors_companion ||
        type?.includes('Background') ||
        type?.includes('Time Lord Doctor')) && (
        <>
          {isPartnerPair ? (
            <>
              <LinkHelper scroll={false} ellipsis href={`/commanders/${cards[0].url}`}>
                {cards[0].name}
              </LinkHelper>
              {cards[1].legal_commander && (
                <LinkHelper scroll={false} ellipsis href={`/commanders/${cards[1].url}`}>
                  {cards[1].name}
                </LinkHelper>
              )}
            </>
          ) : (
            <LinkHelper scroll={false} href={asPartnerLink(card)} primary={['backgrounds', 'partners'].includes(dir)}>
              As Partner
            </LinkHelper>
          )}
        </>
      )}
      {legal_companion && (
        <LinkHelper scroll={false} href={`/themes/${(sanitized_wo || '').split('-')[0]}-companion`}>
          As Companion
        </LinkHelper>
      )}
      {!isPartnerPair && (
        <LinkHelper scroll={false} href={`/cards/${sanitized_wo}`} primary={dir === 'cards'}>
          As Card
        </LinkHelper>
      )}
      {legal_commander && (
        <>
          <LinkHelper scroll={false} href={buildLink('average-decks')} primary={dir === 'average-decks'}>
            Average Deck
          </LinkHelper>
          <LinkHelper scroll={false} href={buildLink('decks')} primary={dir === 'decks'}>
            Decks
          </LinkHelper>
        </>
      )}
    </div>
  )
}

export default NavigationPanelTop
